<template>
  <div class="view contentBody">
    <p class="title">锁粉设置</p>
    <div class="set_wrap" v-if="fans_lock">
      <el-form ref="form" label-width="120px">
        <el-form-item label="员工锁粉设置：" v-if="fans_lock=='no'">
          <el-button type="primary" @click="lockguest" size="small">开启锁粉设置</el-button>
          <p class="red">锁粉设置开启后将不能关闭。</p>
        </el-form-item>
        <el-form-item label="员工锁粉设置：" v-else>
          <p>已开启锁粉。</p>
        </el-form-item>
      </el-form>
      <div class="set_other_wrap">
        <div class="setheader">说明</div>
        <p>1.新客户进入员工小程序，即永远被锁定，员工成为客户的【专属顾问】，可作为线下成单归属凭证。</p>
        <p>3.开启锁粉设置时，原有客户将被首次进入的名片主锁定，管理员可手动调整客户的专属顾问。</p>
      </div>
    </div>
    <lockguestDialog :visible.sync="lockguestdialog" v-if="lockguestdialog" @initPage="initPage"></lockguestDialog>
  </div>
</template>
<script>
import api from "@/api.js";
import lockguestDialog from "@/components/dialog/lockguestDialog.vue";
export default {
  name: "lockguest",
  components: {
    lockguestDialog
  },
  data() {
    return {
      lockguestdialog: false,
      fans_lock: null
    };
  },
  created(){
    this.InitFn()
  },
  methods: {
    //初始化请求
    InitFn() {
      const loading = this.$loading({
        lock: true,
        text: '加载中…',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.axios
          .post(api.fans_index, {})
          .then(response => {
            if (response.data.code == 0) {
              let fans_lock = 'no'
              if(Number(response.data.info.fans_lock)===1){
                fans_lock = 'yes'
              }
              this.fans_lock = fans_lock
              loading.close();
            } else {
            }
          })
          .catch(response => {
          });
    },
    // 锁客
    lockguest() {
      this.lockguestdialog = true;
    },
    initPage(){
      this.InitFn()
    }
  }
};
</script>

